import React, { Component } from 'react';
// import DatePicker from 'react-datepicker';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import moment from 'moment';
// import momentLocaliser from 'react-widgets-moment-localizer';
import momentLocaliser from 'react-widgets-moment';

import 'react-widgets/dist/css/react-widgets.css';

moment.locale('en');
momentLocaliser();

export default class RenderDateField extends Component {
  render() {
    const {
      label,
      input: { onChange, value }
    } = this.props;
    // remember to change all date type to datetime2 in SQL
    return (
      <div className="form-group form-group-sm col-sm-3">
        <div className="row">
          <label className="col-sm-4 col-form-label">{label}</label>
          <div className="col-sm-8">
            <DateTimePicker
              onChange={onChange}
              time={false}
              format="MM/DD/YYYY"
              value={!value ? null : new Date(moment.utc(value).format('MM/DD/YYYY'))}
            />
          </div>
        </div>
      </div>
    );
  }
}
